import { createContext, useContext } from "react";
const context = createContext({
    locale: ""
});
context.displayName = "Tenant";
export default context;
export const TenantConsumer = context.Consumer;
export function useTenant() {
    return useContext(context);
}
//# sourceMappingURL=context.js.map